import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import LangSwitch from 'app/modules/App/SiteHeader/LangSwitch';
import { Collapse } from 'components/Transition';
import pc from 'static/images/icons/pc.png';
import logo from 'static/images/logo/logo.png';
import security from 'stores/security';
import API from 'utils/API';
import classlist from 'utils/classlist';
import MenuSwitch from './MenuSwitch';
import './style.scss';

interface HeaderState {
    showNavMenu: boolean;
    showLanguageMenu: boolean;
    duration: number;
}

const mediaQueryOfScreen: MediaQueryList = window.matchMedia('(max-width: 768px)');

@observer
class Header extends Component<{}, HeaderState> {
    readonly state = {
        showNavMenu: !mediaQueryOfScreen.matches, // 控制header标签功能tab
        showLanguageMenu: false, // 控制中英文切换的tab
        duration: 0
    };

    // header的DOM
    headerNode: HTMLElement;

    componentDidMount() {
        document.addEventListener('click', this.hideNavAndLanguageMenu, false);

        // 判断屏幕切换
        mediaQueryOfScreen.addListener(this.switchScreen);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.hideNavAndLanguageMenu, false);
        mediaQueryOfScreen.removeListener(this.switchScreen);
    }

    reportDataSignup() {
        if (window.gtag) {
            // 点击登录的
            window.gtag('event', 'openacc_openacc', {
                event_category: 'openacc'
            });
        }
    }

    getHeaderRef = (node: HTMLElement) => {
        this.headerNode = node;
    };

    toggleShowNavMenu = (status?: boolean) => {
        const showNavMenu = typeof status === 'boolean' ? status : !this.state.showNavMenu;

        this.setState({
            showNavMenu
        });
    };

    toggleShowLanguageMenu = (status?: boolean) => {
        const showLanguageMenu = typeof status === 'boolean' ? status : !this.state.showLanguageMenu;

        this.setState({
            showLanguageMenu
        });
    };

    hideNavAndLanguageMenu = (event?: MouseEvent) => {
        if (
            mediaQueryOfScreen.matches &&
            !!this.headerNode &&
            !this.headerNode.contains(event?.target as Node) &&
            this.state.showNavMenu
        ) {
            this.toggleShowNavMenu(false);
        }

        if (!!this.headerNode && !this.headerNode.contains(event?.target as Node)) {
            this.toggleShowLanguageMenu(false);
        }
    };

    switchScreen = mediaQuery => {
        const { duration } = this.state;
        // 关闭切换屏幕下拉菜单动画

        if (duration !== 0) {
            this.setState({
                duration: 0
            });
        }

        if (mediaQuery.matches) {
            // 屏幕宽度小于等于768px
            this.toggleShowNavMenu(false);
        } else {
            this.toggleShowNavMenu(true);
        }
    };

    handleMenu = () => {
        const { duration } = this.state;
        // 用户点击按钮时开启下拉菜单动画

        if (duration !== 600) {
            this.setState({
                duration: 600
            });
        }
    };

    render() {
        const { showLanguageMenu, duration, showNavMenu } = this.state;

        return (
            <header className={classlist('site-header', `site-header-default`)} ref={this.getHeaderRef}>
                <div className="site-main">
                    <nav className="site-nav">
                        <a href="/" id="logo">
                            <img src={logo} alt="logo" title="logo" />
                        </a>
                        <div className="header-nav-box">
                            <Collapse in={showNavMenu} timeout={duration}>
                                <nav
                                    className="header-nav-container"
                                    onClick={() => {
                                        this.hideNavAndLanguageMenu();
                                    }}>
                                    <a className="nav-link" href="/">
                                        Investing
                                    </a>
                                    <a className="nav-link" href="/platform">
                                        Platform
                                    </a>
                                    <a className="nav-link" href="/aboutus">
                                        About Us
                                    </a>
                                    <a className="nav-link" href="/pricing">
                                        Pricing
                                    </a>
                                    <a className="nav-link" href="/help">
                                        Help
                                    </a>
                                    {security.isLogin ? (
                                        <NavLink to="/logout" className="nav-link btn-account">
                                            Logout
                                        </NavLink>
                                    ) : (
                                        <>
                                            <NavLink to="/login" className="nav-link">
                                                Log In
                                            </NavLink>
                                            <a
                                                href="/accounts"
                                                className="nav-link btn-open"
                                                onClick={this.reportDataSignup}>
                                                Open Account
                                            </a>
                                        </>
                                    )}
                                    <a className="nav-link web-app" href={API.PC.host()} target="view_window">
                                        <img src={pc} alt="pc" title="pc" />
                                        <span>Web Trading</span>
                                    </a>
                                    <LangSwitch
                                        onClick={ev => {
                                            ev.preventDefault();
                                            ev.stopPropagation();

                                            this.toggleShowLanguageMenu();
                                        }}
                                        showLanguageMenu={showLanguageMenu}
                                    />
                                </nav>
                            </Collapse>
                            <MenuSwitch
                                opened={
                                    typeof window === 'undefined' || !(mediaQueryOfScreen as MediaQueryList).matches
                                        ? false
                                        : showNavMenu
                                }
                                onClick={event => {
                                    event.preventDefault();

                                    this.toggleShowNavMenu();
                                    this.handleMenu();
                                }}
                            />
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}

export default Header;
